import PropTypes from 'prop-types';

const HeaderPropType = PropTypes.exact({
	title: PropTypes.string,
	icon: PropTypes.string,
	description: PropTypes.string,
	className: PropTypes.string,
	rowSpan: PropTypes.number,
	colSpan: PropTypes.number,
	sorting: PropTypes.exact({
		key: PropTypes.string.isRequired,
		remote: PropTypes.bool.isRequired,
		direction: PropTypes.oneOf(['asc', 'desc']).isRequired
	})
}).isRequired;

const ColumnPropType = PropTypes.exact({
	className: PropTypes.string,
	format: PropTypes.func,
	hint: PropTypes.func,
	render: PropTypes.func
});

const TableItemPropType = PropTypes.exact({
	index: PropTypes.string.isRequired,
	header: HeaderPropType,
	column: ColumnPropType
}).isRequired;

const TableItemsPropType = PropTypes.arrayOf(TableItemPropType).isRequired;

const TablePropType = PropTypes.arrayOf(TableItemsPropType).isRequired;

const HeaderItemPropType = PropTypes.exact({
	index: PropTypes.string.isRequired,
	header: HeaderPropType
}).isRequired;

const ColumnItemPropType = PropTypes.exact({
	index: PropTypes.string.isRequired,
	column: ColumnPropType
}).isRequired;

const HeaderItemsPropType =  PropTypes.arrayOf(HeaderItemPropType).isRequired;

const HeadersPropType = PropTypes.arrayOf(HeaderItemsPropType).isRequired;

const ColumnsPropType = PropTypes.arrayOf(ColumnItemPropType).isRequired;

const RowPropType = PropTypes.shape({
	id: PropTypes.any.isRequired
}).isRequired;

const RowsPropType = PropTypes.arrayOf(RowPropType).isRequired;

const RenderPropType = PropTypes.func.isRequired;

const PayloadPropType = PropTypes.object;

export default {
	TablePropType,
	HeadersPropType,
	HeaderItemsPropType,
	ColumnsPropType,
	RowsPropType,
	RowPropType,
	RenderPropType,
	PayloadPropType
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/prop-types.js